import SituacaoPedidoService from "@/services/SituacaoPedidoService";

export const situacaoPedido = {
  namespaced: true,
  state: {
    situacaoPedido: {},
  },
  actions: {
    getSituacaoPedido({ commit }, payload) {
      return SituacaoPedidoService.GetSituacaoPedido(payload).then(
        (situacaoPedido) => {
          return Promise.resolve(situacaoPedido);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postSituacaoPedido({ commit }, payload) {
      return SituacaoPedidoService.PostSituacaoPedido(payload).then(
        (situacaoPedido) => {
          return Promise.resolve(situacaoPedido);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putSituacaoPedido({ commit }, payload) {
      return SituacaoPedidoService.PutSituacaoPedido(payload).then(
        (situacaoPedido) => {
          return Promise.resolve(situacaoPedido);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteSituacaoPedido({ commit }, payload) {
      return SituacaoPedidoService.DeleteSituacaoPedido(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getSituacaoPedidoOData({ commit }, payload) {
      return SituacaoPedidoService.GetSituacaoPedidoOData(payload).then(
        (situacaoPedido) => {
          return Promise.resolve(situacaoPedido);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default situacaoPedido;
